import { apiService } from '../api/api-client';
import type { ActivityEvent } from '@/types';

export const activityService = {
  /**
   * Get the normalized activity / history timeline for a position
   * (ADR-0001 §5 event rows; Phase-9 reconstruction-on-read projection).
   *
   * The `/audit/` endpoint returns an UN-PAGINATED plain list (09-02), sorted
   * by `occurred_at` ascending. Returned verbatim — no client re-sort, no field
   * re-derivation (the FE re-groups by day itself in `groupActivityByDay`).
   */
  async getActivity(id: number): Promise<ActivityEvent[]> {
    // LR-436 D1: /audit/ returns a bare list today, but guard the runtime shape
    // so a future move to a paginated {results} envelope can't hand a non-array
    // to groupActivityByDay (which does .forEach and would throw). Tolerate a bare
    // list and a {results} envelope; anything else (null / undefined / scalar, or
    // an object whose `results` isn't an array) degrades to [] rather than throwing
    // on the property access itself — the guard must never crash on the very inputs
    // it exists to absorb (LR-436 r1).
    const data = await apiService.get<unknown>(`/positions/${id}/audit/`);
    if (Array.isArray(data)) return data as ActivityEvent[];
    if (data && typeof data === 'object' && Array.isArray((data as { results?: unknown }).results)) {
      return (data as { results: ActivityEvent[] }).results;
    }
    return [];
  },
};
